import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/builder/image-question-builder.jpg'


const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "content-overlay" }
const _hoisted_3 = { class: "content-button-request" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      class: "content-img",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-text" }, "Got questions about your build options?", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["ContactUsLink"], {
          class: "request",
          animationName: "''",
          toContactUsForm: false,
          text: 'Book a free consultation',
          isButtonCallBackModal: true,
          linkCalendly: $setup.CALENDLY_BUILD_LINK
        }, null, 8, ["linkCalendly"])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-text" }, "No commitment. No obligations.", -1))
    ])
  ]))
}